import React from 'react';
import PropTypes from 'prop-types';

// import assets
import './interviewModule.scss';

const InterviewModuleView = props => (
  <div className="m-article-module">
    <div className={'m-interview-module'}>
      {props.pairs.map(pair => (
        <div key={pair.question} className={'m-interview-module__pair'}>
          <div className={'m-interview-module__question'} dangerouslySetInnerHTML={{ __html: pair.question }} />
          <div className={'m-interview-module__answer'} dangerouslySetInnerHTML={{ __html: pair.answer }} />
        </div>
      ))}
    </div>
  </div>
);

InterviewModuleView.propTypes = {
  pairs: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string,
    answer: PropTypes.string,
  }).isRequired),
};

InterviewModuleView.defaultProps = {
  pairs: [],
};

export default InterviewModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/InterviewModule/InterviewModuleView.jsx